import styled from 'styled-components';

import { GENERAL_SECTIONS } from 'components/notificationPreferences/generalSections';
import InboundReferralSectionPreferences from 'components/notificationPreferences/InboundReferralSectionPreferences';
import PushDevicesSection from 'components/notificationPreferences/PushDevicesSection';
import { Flags } from 'constants/flags';
import { useProfile } from 'context/profile';
import { BodySmall, H3 } from 'styles/typography';

// The one form key the General row lives under. Its siblings are the care-coordination rows,
// keyed by group-type ids (uuids), and the inbound-referrals key, so it never collides.
export const GENERAL_FORM_KEY = 'general';

type Props = {
  disabled?: boolean;
  // The devices belong to the signed-in user, so an admin viewing someone else's preferences
  // never sees them.
  showDevices?: boolean;
};

function GeneralPreferencesContainer({ disabled = false, showDevices = false }: Props) {
  const { profile } = useProfile();

  return (
    <Container>
      <SelectSection>
        <StyledH3>Select Notifications</StyledH3>
        <SectionDescription>
          The following notifications are not specific to one area of Olio and apply generally across the application.
        </SectionDescription>
        {GENERAL_SECTIONS.map((section) => (
          <InboundReferralSectionPreferences
            key={section.category}
            section={section}
            formKey={GENERAL_FORM_KEY}
            testIdPrefix='general-section'
            disabled={disabled}
          />
        ))}
      </SelectSection>
      {showDevices && profile.hasFlag(Flags.PushNotifications) && <PushDevicesSection />}
    </Container>
  );
}

const Container = styled.div`
  max-width: 900px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const SelectSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const StyledH3 = styled(H3)`
  margin-bottom: 12px;
`;

const SectionDescription = styled(BodySmall)`
  font-size: 12px;
  margin-bottom: 24px;
`;

export default GeneralPreferencesContainer;
